import React, {Component} from 'react';
import * as PropTypes from 'prop-types';
import {LargePrimaryButton} from '@worthy-npm/clarity';
import * as ReactScroll from 'react-scroll';


class Navigator extends Component {


  constructor(props){
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  /**
   *  Scroll to submission form
   */
  onClick(stopAnimation){
    let {top} = this.props.submissionFormRef.current.getBoundingClientRect();
    ReactScroll.animateScroll.scrollTo(top - 115, {
      duration: 800,
      delay: 0,
      smooth: true
    });
    stopAnimation();
  }

  /**
   * Render buttons according to props
   * @returns {*}
   */
  renderButtons(){
    return this.props.buttons.map(({text}, index) => {
      return <LargePrimaryButton click={(stopAnimation) => this.onClick(stopAnimation)} text={text} key={index} data-label={null} data-section={'SellYourItem'}/>;
    });
  }

  render(){
    const {title, subtitle} = this.props,
        buttons = this.renderButtons();

    return <React.Fragment>
      <div className="text center">
        {title ? <h1 className="title">{title}</h1> : null}
        {subtitle ? <h4 className='subtitle'>{subtitle}</h4> : null}
      </div>
      <div className="buttons-n-icons">{buttons}</div>
    </React.Fragment>
  }
}

Navigator.propTypes = {
  buttons: PropTypes.array,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  submissionFormRef: PropTypes.object
};

Navigator.defaultProps = {
  buttons: [],
  title: '',
  subtitle: ''
};

export default Navigator;